import { Component } from 'react'
import mediaFiles from '../../../../../apis/wpApi/mediaFiles'
import Button from '../../../../general/Button'
import ImageDisplayAndDelete from '../ImagesDisplayAndDelete'
import getImageUrl from '../../../../../functions/getImageUrl'

class ImageDisplayDeleteAndUpload extends Component {
    constructor(props) {
        super(props)

        this.onUploadEndSuccess = this.onUploadEndSuccess.bind(this)
        this.onUploadEndError = this.onUploadEndError.bind(this)
    }

    formatDataObj(data) {
        const { id, url, alt, format } = data

        return {
            id: parseInt(id),
            source_url: url,
            alt_text: alt,
            format: format
        }
    }

    onUploadStart() {
        const { onUploadStart, image, imageType, movieTitle } = this.props
        const isPoster = !(imageType === 'backgrounds' || imageType === 'ambient')
        const {finalImageURl, imageUrl } = getImageUrl(image.url, false, isPoster, false, true)

        onUploadStart()

        mediaFiles.createByUrl(
            movieTitle,
            imageType,
            finalImageURl || imageUrl,
            this.onUploadEndSuccess, 
            this.onUploadEndError
        )
    }

    onUploadEndSuccess(data) {
        const { replaceUploadAt, onUploadEndSuccess } = this.props

        const formatedData = this.formatDataObj(data)

        if(false === replaceUploadAt) {
            onUploadEndSuccess(formatedData)
        } else {
            onUploadEndSuccess(formatedData, replaceUploadAt)
        }
    }

    onUploadEndError(error) {
        const { onUploadEndError } = this.props

        onUploadEndError(error)
    }

    render() {

        const { field, index, image, isDisabled, onDeleteImage, imagePosition, imageType, imagePositionX } = this.props

        return (
            <div>
                <ImageDisplayAndDelete
                    field={field}
                    index={index}
                    imageType={imageType}
                    image={image}
                    imagePositionX={imagePositionX}
                    onDeleteImage={onDeleteImage}
                    imagePosition={imagePosition}
                />

                <Button
                    className="images-upload-button-local"
                    transId={'images_uploads_upload_local'}
                    onClick={() => this.onUploadStart()}
                    hideText={false}
                    disabled={isDisabled}
                />
            </div>
        )
    }
    
}

export default ImageDisplayDeleteAndUpload